import { Row, Col } from "reactstrap";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

const CustomTextField = styled((props) => <TextField {...props} />)(
  ({ ownerState }) => ({
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: ownerState.color,
      },
      "&:hover fieldset": {
        borderColor: ownerState.color,
      },
      "&.Mui-focused fieldset": {
        borderColor: ownerState.color,
      },
    },
    "& .MuiInputBase-input": {
      color: ownerState.darkMode ? "#ffffff" : "#000000",
      paddingTop: "10px",
    },
    "& .MuiInputLabel-root": {
      color: ownerState.darkMode ? "#ffffff" : "#000000",
    },
  })
);

const OfferNotesSection = ({ darkMode, selectedItemsSize, handleChange }) => {
  const { color } = useSelector((state) => state.global);

  return (
    <Row className="mx-2 mt-4">
      <Col xs={12}>
        <CustomTextField
          label="Your note to restaurant"
          fullWidth
          multiline
          rows={3}
          placeholder="Any special requests for this offer..."
          name="notes"
          value={selectedItemsSize?.notes || ""}
          onChange={(e) => handleChange(e)}
          variant="outlined"
          ownerState={{ darkMode, color }}
        />
      </Col>
    </Row>
  );
};

export default OfferNotesSection;
